"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueIllustrationNames = getUniqueIllustrationNames;
exports.getIllustrationNamePropType = getIllustrationNamePropType;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var illustrationNames;
var propType;

function getUniqueIllustrationNames() {
  if (!illustrationNames) {
    illustrationNames = process.env.NODE_ENV === 'production' ? [] : Object.keys(require('ui-images/metadata').illustrations);
  }

  return illustrationNames;
}

function getIllustrationNamePropType() {
  if (!propType) {
    propType = _propTypes.default.oneOf(getUniqueIllustrationNames());
  }

  return (0, _createChainablePropType.default)(propType, 'illustrationName');
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/utils/propTypes/illustrationName.js
// module id = 324
// module chunks = 5 6